const getBaseUrl = () => {
  return  'https://api.jianzeppt.com/';
};
export default getBaseUrl;
